module.exports = __webpack_public_path__ + "img/yingxiaotuiguang.952b5836.gif";